import { CopyRightContainer } from './CopyRightContainer';
import React from 'react';
import { BrandContext } from '../../../contexts/branding';
import { LocaleContext } from '../../../contexts/language';
import FormattedMessage from 'react-intl/lib/src/components/message';
import IntlProvider from 'react-intl/lib/src/components/provider';
import ar from './ar.json';
import en from './en.json';
import { Link } from 'gatsby-theme-material-ui';

const languages = {
  ar,
  en
};


export const CopyRightBlock = React.memo(() => {
  const brand = React.useContext(BrandContext);
  const localeConfig = React.useContext(LocaleContext);
  const companyName = brand.layout.footer.copyright.brandName[localeConfig?.lang||'en'] || brand.layout.footer.copyright.brandName;
  const companyTitle = brand.layout.footer.copyright.brandTitle[localeConfig?.lang||'en'] || brand.layout.footer.copyright.brandTitle;
  return (
    <CopyRightContainer spacing={2} sx={{ p:1 }}>
      <div>
        <IntlProvider locale={localeConfig.lang} messages={languages[localeConfig?.lang||'en'] || languages.en}>
          <FormattedMessage
            id={'layout.copyright.notice'}
            defaultMessage={'<c>CopyRightIcon</c> {year} <a>CompanyName</a> <s>Separator</s> All rights Reserved.'}
            values={{
              c: ()=> <span>&copy;</span>,
              year: new Date().getFullYear().toString(),
              s: () => <span className="sep"> | </span>,
              a: () => <Link
                to={'/'}
                color={'inherit'}
                title={companyTitle}>
                {companyName}
              </Link>
            }}
          />
        </IntlProvider>
      </div>
      {brand.layout.footer.copyright.extra ? (
        <div>
          {brand.layout.footer.copyright.extra}
        </div>
      ) : null}
    </CopyRightContainer>
  );
});

CopyRightBlock.displayName = 'CopyRightBlock';

